import React from 'react'

const AddNmotUserDialogContext = React.createContext()

export default AddNmotUserDialogContext
